export function SiteDevIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#prefix__clip0_801_130)"
        stroke="#5200FF"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M22 26h6M12 14l6 5-6 5" />
        <path d="M32 38H8a6 6 0 01-6-6V8a6 6 0 016-6h24a6 6 0 016 6v24a6 6 0 01-6 6z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0_801_130">
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function ReDesignIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.53 26.1V15.264M34.056 32.315l2.997-6.078-7.52-10.974-7.522 10.974 2.997 6.078M25.008 32.315h9.047V38h-9.047v-5.684zM25.389 5.215C17.945 7.07 12.42 13.777 12.42 21.794M26.158 5.221L8.632 5.202M5.79 8.052a2.843 2.843 0 010-5.685 2.843 2.843 0 010 5.685zM30.895 8.632h-2.843a1.895 1.895 0 01-1.894-1.895V3.895c0-1.046.848-1.895 1.894-1.895h2.843c1.045 0 1.894.849 1.894 1.895v2.842a1.895 1.895 0 01-1.895 1.895zM13.842 28.426H11a1.895 1.895 0 01-1.895-1.895v-2.842c0-1.046.85-1.895 1.895-1.895h2.842c1.046 0 1.895.849 1.895 1.895v2.842a1.894 1.894 0 01-1.895 1.895z"
        stroke="#5200FF"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CommerceIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.5 17.158v-7.58C27.5 5.394 24.142 2 20 2c-4.142 0-7.5 3.393-7.5 7.579v7.579"
        stroke="#5200FF"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.125 38H6.875A1.886 1.886 0 015 36.105V13.37c0-1.046.84-1.895 1.875-1.895h26.25c1.035 0 1.875.849 1.875 1.894v22.737C35 37.151 34.16 38 33.125 38z"
        stroke="#5200FF"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function DesignDevLogoIcon(props) {
  return (
    <svg
      width={44}
      height={44}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 20.57v3L20 27l4-10 8 3.43v3L26 27l6-3.57v-3L24 17l-4 10-8-3.43v-3zm0 0L18 17l-6 3.57z"
        stroke="#FF7A00"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 42c11.046 0 20-8.954 20-20S33.046 2 22 2 2 10.954 2 22s8.954 20 20 20z"
        stroke="#FF7A00"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function DesignIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M30 8.285c1.85-.317 3.788-.5 5.912-.569C37.048 7.68 38 8.533 38 9.61v22.428c0 1.027-.866 1.876-1.948 1.891-6.184.09-10.84 1.17-16.052 4.072-5.212-2.903-9.868-3.983-16.052-4.07C2.866 33.915 2 33.064 2 32.037V9.61c0-1.059.918-1.929 2.034-1.894C10.176 7.902 14.812 8.997 20 11.75"
        stroke="#FF7A00"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30 27.083V3.918c0-1.382-1.532-2.346-2.834-1.727C23.654 3.86 20.694 7.25 20 10.74V38c.792-3.977 4.522-7.823 8.662-9.14.804-.256 1.338-.974 1.338-1.777z"
        stroke="#FF7A00"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function StyleIcon(props) {
  return (
    <svg
      width={36}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M34 8v27.997a2 2 0 01-3.2 1.6L18 28 5.2 37.597a2 2 0 01-3.2-1.6V8a6 6 0 016-6h20a6 6 0 016 6z"
        stroke="#FF7A00"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34 28.356l-16-12-16 12"
        stroke="#FF7A00"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function SeoIcon(props) {
  return (
    <svg
      width={60}
      height={60}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.25 52.5h37.5-.024c2.05 0 3.75-1.7 3.75-3.75v-7.525c0-2.075-1.7-3.75-3.75-3.75h-37.55a3.745 3.745 0 00-3.75 3.75v7.5c0 2.05 1.675 3.725 3.75 3.725l.075.05z"
        stroke="#FFC635"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.575 15.125l-4.8 4.775-2.875-2.875"
        stroke="#fff"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.502 10H11.227a3.745 3.745 0 00-3.75 3.75v7.5c0 2.05 1.675 3.725 3.75 3.725h16.25"
        stroke="#FFC635"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.75 6.25a11.25 11.25 0 100 22.5 11.25 11.25 0 000-22.5z"
        stroke="#fff"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SmmIcon(props) {
  return (
    <svg
      width={60}
      height={60}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 12a9 9 0 019-9h36a9 9 0 019 9v43.5a1.5 1.5 0 01-2.295 1.272l-9.231-5.77H12a9 9 0 01-9-9V12z"
        stroke="#FFC635"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 24h26M17 32h26"
        stroke="#fff"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function MarketingIcon(props) {
  return (
    <svg
      width={60}
      height={60}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M28.051 37.53l-14.94-.005C8.08 37.525 4 33.414 4 28.344v-2.288c0-5.07 4.08-9.178 9.113-9.178h14.94l8.82-6.07c3.025-2.081 7.127.1 7.127 3.79v25.216c0 3.69-4.105 5.871-7.127 3.788l-8.822-6.073zM28.055 16.882V37.53"
        stroke="#FFC635"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.834 37.53l3.483 8.85A4.098 4.098 0 0018.12 49c2.895 0 4.876-2.969 3.808-5.706l-2.253-5.765"
        stroke="#FFC635"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50 23v7.5M56 20v14"
        stroke="#fff"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function MarketplaceIcon(props) {
  return (
    <svg
      width={60}
      height={60}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M44.445 15.556v-2.89a8.667 8.667 0 10-17.334 0v2.89"
        stroke="#FFC635"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.89 53.111H50.22A5.778 5.778 0 0056 47.333v-26a5.778 5.778 0 00-5.778-5.777H21.333a5.778 5.778 0 00-5.778 5.777V30"
        stroke="#FFC635"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.777 56h23.111a5.778 5.778 0 005.778-5.778V35.778A5.778 5.778 0 0032.888 30H9.778a5.778 5.778 0 00-5.779 5.778v14.444A5.778 5.778 0 009.777 56z"
        stroke="#fff"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.555 38.667v1.444a5.778 5.778 0 0011.555 0v-1.444"
        stroke="#fff"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function HostingIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.5 6.29h-8.442c-.662 0-1.282-.318-1.654-.852l-1.81-2.588A2.015 2.015 0 0015.942 2H10.5c-2.21 0-4 1.742-4 3.892v15.567c0 2.15 1.79 3.892 4 3.892h19c2.21 0 4-1.741 4-3.892V10.183c0-2.149-1.79-3.892-4-3.892zM20 25.39v6.772M23 35.081h13M4 35.081h13M22.121 33.017a2.863 2.863 0 010 4.128 3.06 3.06 0 01-4.242 0 2.863 2.863 0 010-4.128 3.06 3.06 0 014.242 0z"
        stroke="#0093D1"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function VebIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#prefix__clip0_821_560)"
        stroke="#0093D1"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M26.325 35l-2.92 3M15.622 38H11.73a9.599 9.599 0 01-6.88-2.929A10.143 10.143 0 012 28V12c0-2.652 1.025-5.196 2.85-7.071A9.598 9.598 0 0111.73 2h15.567a9.598 9.598 0 016.88 2.929A10.143 10.143 0 0137.027 12v4M11.73 12v16M19.514 12v8M27.297 12v4" />
        <path d="M31.189 37c3.761 0 6.81-3.134 6.81-7s-3.049-7-6.81-7c-3.762 0-6.811 3.134-6.811 7s3.05 7 6.81 7z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0_821_560">
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function SupportIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#prefix__clip0_821_571)"
        stroke="#0093D1"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21.888 15.394a5.099 5.099 0 010 7.212 5.099 5.099 0 01-7.212 0 5.099 5.099 0 010-7.212 5.099 5.099 0 017.212 0z" />
        <path d="M31.032 19c0-.562-.05-1.122-.118-1.666l3-2.346a1.7 1.7 0 00.424-2.184L31.67 8.19a1.699 1.699 0 00-2.1-.726L26.89 8.54c-.532.214-1.126.124-1.606-.192a12.917 12.917 0 00-1.288-.748c-.512-.256-.886-.724-.968-1.29l-.408-2.856A1.693 1.693 0 0020.942 2h-5.32c-.843 0-1.559.62-1.679 1.454l-.412 2.86c-.08.564-.452 1.03-.96 1.288-.446.228-.878.482-1.292.756-.478.314-1.07.398-1.6.186l-2.684-1.08a1.694 1.694 0 00-2.1.726l-2.668 4.614a1.696 1.696 0 00.422 2.184l3 2.346A13.47 13.47 0 005.53 19c0 .56.05 1.122.12 1.666l-3 2.346a1.699 1.699 0 00-.424 2.184l2.668 4.614a1.699 1.699 0 002.1.726l2.686-1.078c.53-.214 1.122-.128 1.598.188.416.276.846.528 1.292.756.51.258.88.722.962 1.288l.41 2.858c.12.832.836 1.452 1.678 1.452h2.663M26 28h12M26 33h12M26 38h12" />
      </g>
      <defs>
        <clipPath id="prefix__clip0_821_571">
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function BgDev(props) {
  return (
    <svg
      width={1896}
      height={951}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1512 3l-384 384 384 384 384-384L1512 3z"
        fill="#6851F3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M564-177L0 387l564 564 564-564-564-564z"
        fill="#6551E3"
      />
    </svg>
  );
}
export function BgDesign(props) {
  return (
    <svg
      width={2054}
      height={1747}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle opacity={0.9} cx={1664} cy={1357} r={390} fill="#FFCA63" />
      <circle opacity={0.9} cx={1478} cy={-78} r={390} fill="#FFCA63" />
      <circle opacity={0.9} cx={445} cy={336} r={445} fill="#FBA31F" />
    </svg>
  );
}
export function BgSeo(props) {
  return (
    <svg
      width={1901}
      height={918}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M486.928 480L622 169 311 304.072 0 169l135.072 311L0 791l311-135.072L622 791 486.928 480z"
        fill="#42FFB0"
      />
      <path
        d="M1442 0l129.82 329.175L1901 459l-329.18 129.825L1442 918l-129.82-329.175L983 459l329.18-129.825L1442 0z"
        fill="#00CF85"
      />
    </svg>
  );
}
export function BgSupport(props) {
  return (
    <svg
      width={1440}
      height={674}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1440 768L996 0 552 768h888z"
        fill="#4F8ABF"
      />
      <path
        opacity={0.4}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M685 708L460 319 235 708h450z"
        fill="#53A0E7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0l263 152L0 304V0z"
        fill="#396894"
      />
    </svg>
  );
}
export function BgDevMiddle(props) {
  return (
    <svg
      width={1386}
      height={1159}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1029 0L672 357l357 357 357-357L1029 0z"
        fill="#6851F3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M579.5 0L0 579.5 579.5 1159 1159 579.5 579.5 0z"
        fill="#6551E3"
      />
    </svg>
  );
}
export function BgDevSmall(props) {
  return (
    <svg
      width={1296}
      height={1318}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M954 634L612 976l342 342 342-342-342-342z"
        fill="#6851F3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M405 0L0 405l405 405 405-405L405 0z"
        fill="#6551E3"
      />
    </svg>
  );
}
export function BgDesignMiddle(props) {
  return (
    <svg
      width={1252}
      height={1272}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle opacity={0.9} cx={862} cy={1116} r={390} fill="#FFCA63" />
      <circle opacity={0.9} cx={390} cy={-146} r={390} fill="#FFCA63" />
    </svg>
  );
}
export function BgDesignSmall(props) {
  return (
    <svg
      width={816}
      height={1318}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle opacity={0.9} cx={195} cy={1123} r={195} fill="#FFCA63" />
      <circle opacity={0.9} cx={640.5} cy={-0.5} r={175.5} fill="#FFCA63" />
    </svg>
  );
}
export function BgSeoMiddle(props) {
  return (
    <svg
      width={1455}
      height={992}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M959 0l140.29 355.71L1455 496l-355.71 140.29L959 992 818.71 636.29 463 496l355.71-140.29L959 0z"
        fill="#00CF85"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M306.874 274L392 78l-196 85.126L0 78l85.126 196L0 470l196-85.126L392 470l-85.126-196z"
        fill="#42FFB0"
      />
    </svg>
  );
}
export function BgSeoSmall(props) {
  return (
    <svg
      width={650}
      height={1318}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M435.309 195L520 0 325 84.691 130 0l84.691 195L130 390l195-84.691L520 390l-84.691-195z"
        fill="#42FFB0"
      />
      <path
        d="M325 668l91.924 233.076L650 993l-233.076 91.92L325 1318l-91.924-233.08L0 993l233.076-91.924L325 668z"
        fill="#00CF85"
      />
    </svg>
  );
}
export function BgSupportSmall(props) {
  return (
    <svg
      width={819}
      height={684}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M819 708L409.5 0 0 708h819z"
        fill="#4F8ABF"
      />
    </svg>
  );
}
export function CloseIcon({ mainClassName }) {
  return (
    <svg
      width={40}
      height={40}
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
    >
      <path
        d="M8 8l24 24M32 8L8 32"
        stroke="#8D90AB"
        strokeWidth={4}
        strokeLinecap="round"
      />
    </svg>
  );
}
export function CloseIconMobile({ mainClassName }) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
    >
      <path
        d="M4.8 4.8l14.4 14.4M19.2 4.8L4.8 19.2"
        stroke="#8D90AB"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function LikeIcon({ mainClassName }) {
  return (
    <svg
      width={24}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
    >
      <path
        d="M16.933 0C21.16 0 24 4.098 24 7.92 24 15.661 12.213 22 12 22c-.213 0-12-6.339-12-14.08C0 4.098 2.84 0 7.067 0 9.493 0 11.08 1.251 12 2.351 12.92 1.251 14.507 0 16.933 0z"
        fill="#fff"
      />
    </svg>
  );
}
export function LikeIconMobile({ mainClassName }) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
    >
      <path
        d="M10.878 2C13.343 2 15 4.421 15 6.68 15 11.254 8.124 15 8 15c-.124 0-7-3.746-7-8.32C1 4.421 2.657 2 5.122 2 6.538 2 7.463 2.74 8 3.39 8.537 2.74 9.462 2 10.878 2z"
        fill="#fff"
      />
    </svg>
  );
}

export function ShareIcon({ mainClassName, strokeClassName }) {
  return (
    <svg
      width={28}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
    >
      <path
        d="M17.857 10.333h2.572c1.42 0 2.571 1.094 2.571 2.444v9.778C23 23.905 21.85 25 20.43 25H7.572C6.152 25 5 23.905 5 22.555v-9.777c0-1.35 1.152-2.445 2.572-2.445h2.571M14 17.667V3M17.857 6.667L14 3l-3.857 3.667"
        stroke="#000536"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={strokeClassName}
      />
    </svg>
  );
}
export function ShareIconMobile({ mainClassName, strokeClassName }) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
    >
      <path
        d="M10.204 5.904h1.47c.811 0 1.469.626 1.469 1.397v5.588c0 .77-.658 1.396-1.47 1.396H4.328c-.812 0-1.47-.625-1.47-1.396V7.3c0-.771.658-1.397 1.47-1.397h1.47M8 10.095V1.714M10.204 3.81L8 1.713 5.796 3.809"
        stroke="#000536"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={strokeClassName}
      />
    </svg>
  );
}
export function ArrowIcon(props) {
  return (
    <svg
      width={24}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5 26a1.5 1.5 0 003 0h-3zM13.06.94a1.5 1.5 0 00-2.12 0l-9.547 9.545a1.5 1.5 0 102.122 2.122L12 4.12l8.485 8.486a1.5 1.5 0 102.122-2.122L13.06.94zM13.5 26V2h-3v24h3z"
        fill="#fff"
      />
    </svg>
  );
}

export const ProjectLogoIcon = ({ mainClassName, fillClassName }) => {
  return (
    <svg className={mainClassName} width="275" height="58" viewBox="0 0 275 58" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="230.294" width="10.2353" height="10.2353" fill="#FF8585" />
      <rect x="247.353" width="10.2353" height="10.2353" fill="#FFB84F" />
      <rect x="264.412" width="10.2353" height="10.2353" fill="#7AE448" />
      <path className={fillClassName} d="M0 57.0252V10.2353H38.5541V57.0252H30.5922V17.5787H7.9619V57.0252H0Z" fill="#232A72" />
      <path className={fillClassName} d="M62.2504 58C58.6824 58 55.5659 57.2093 52.9009 55.628C50.2359 54.0467 48.1656 51.8697 46.69 49.0969C45.2363 46.3025 44.5095 43.0965 44.5095 39.479C44.5095 35.7964 45.2584 32.5688 46.756 29.7961C48.2537 27.0233 50.335 24.8571 53 23.2975C55.665 21.7378 58.7484 20.958 62.2504 20.958C65.8404 20.958 68.9679 21.7486 71.6328 23.33C74.2978 24.9113 76.3681 27.0992 77.8438 29.8936C79.3194 32.6663 80.0573 35.8614 80.0573 39.479C80.0573 43.1182 79.3084 46.335 77.8108 49.1294C76.3351 51.9021 74.2648 54.0792 71.5998 55.6605C68.9348 57.2202 65.8183 58 62.2504 58ZM62.2504 50.6566C65.4219 50.6566 67.7785 49.6168 69.3203 47.5373C70.862 45.4577 71.6328 42.7716 71.6328 39.479C71.6328 36.0781 70.851 33.3703 69.2872 31.3557C67.7235 29.3195 65.3779 28.3014 62.2504 28.3014C60.114 28.3014 58.352 28.778 56.9644 29.7311C55.5989 30.6626 54.5858 31.9731 53.925 33.6627C53.2643 35.3307 52.9339 37.2695 52.9339 39.479C52.9339 42.8799 53.7158 45.5985 55.2796 47.6347C56.8653 49.6493 59.1889 50.6566 62.2504 50.6566Z" fill="#232A72" />
      <path className={fillClassName} d="M82.7111 57.0252V50.4616C84.0105 50.6999 85.0126 50.6782 85.7174 50.3966C86.4222 50.0934 86.9508 49.5302 87.3032 48.707C87.6556 47.8838 87.9639 46.7899 88.2282 45.4252C88.5806 43.4973 88.889 41.2769 89.1533 38.7641C89.4396 36.2514 89.6819 33.5653 89.8801 30.7059C90.1003 27.8465 90.2985 24.9221 90.4747 21.9328H116.739V57.0252H108.81V29.2762H97.4786C97.3684 30.6842 97.2363 32.2655 97.0821 34.0202C96.928 35.7531 96.7628 37.5077 96.5866 39.284C96.4104 41.0603 96.2122 42.75 95.9919 44.3529C95.7937 45.9343 95.5844 47.2881 95.3642 48.4146C94.8576 50.949 94.1308 52.9528 93.1838 54.4258C92.2587 55.8988 90.9593 56.8411 89.2854 57.2527C87.6115 57.6859 85.4201 57.6101 82.7111 57.0252Z" fill="#232A72" />
      <path className={fillClassName} d="M124.666 57.0252L124.633 21.9328H132.595V33.6302H139.004C139.995 33.6302 141.107 33.6519 142.341 33.6952C143.596 33.7386 144.642 33.836 145.479 33.9877C147.483 34.4209 149.19 35.1141 150.6 36.0672C152.031 37.0204 153.122 38.2659 153.871 39.8039C154.619 41.3419 154.994 43.194 154.994 45.3602C154.994 48.4579 154.179 50.9382 152.549 52.8011C150.941 54.6424 148.673 55.8988 145.743 56.5703C144.862 56.7653 143.783 56.8952 142.506 56.9602C141.25 57.0035 140.116 57.0252 139.103 57.0252H124.666ZM132.595 50.884H139.797C140.281 50.884 140.821 50.8624 141.416 50.819C142.01 50.7757 142.583 50.6782 143.134 50.5266C144.125 50.2667 144.995 49.6818 145.743 48.772C146.514 47.8405 146.9 46.7033 146.9 45.3602C146.9 43.9522 146.514 42.7933 145.743 41.8835C144.973 40.9737 144.026 40.378 142.902 40.0964C142.396 39.9664 141.867 39.8797 141.317 39.8364C140.766 39.7931 140.259 39.7714 139.797 39.7714H132.595V50.884Z" fill="#232A72" />
      <path className={fillClassName} d="M173.617 58C170.226 58 167.131 57.296 164.334 55.888C161.537 54.4799 159.334 52.552 157.727 50.1042L164.004 45.9776C165.281 47.4723 166.702 48.6312 168.265 49.4543C169.829 50.2558 171.569 50.6566 173.485 50.6566C175.489 50.6566 177.064 50.2233 178.209 49.3569C179.355 48.4904 179.927 47.3315 179.927 45.8801C179.927 44.6021 179.542 43.7031 178.771 43.1832C178 42.6416 176.987 42.3167 175.732 42.2084C174.476 42.1001 173.133 42.0459 171.701 42.0459H169.058V35.8398H171.668C173.672 35.8398 175.346 35.6123 176.69 35.1574C178.055 34.7025 178.738 33.6952 178.738 32.1356C178.738 30.7275 178.209 29.7311 177.152 29.1462C176.095 28.5397 174.862 28.2364 173.452 28.2364C171.734 28.2364 170.038 28.5938 168.364 29.3087C166.691 30.0235 165.193 30.89 163.871 31.9081L159.378 26.5793C161.361 24.8463 163.574 23.4816 166.019 22.4851C168.464 21.467 171.073 20.958 173.849 20.958C176.139 20.958 178.276 21.3479 180.258 22.1277C182.262 22.9076 183.87 24.0773 185.081 25.637C186.315 27.1966 186.931 29.1246 186.931 31.4207C186.931 33.067 186.568 34.6159 185.841 36.0672C185.136 37.5186 184.002 38.8941 182.438 40.1938L182.339 37.6594C183.55 38.1576 184.575 38.8508 185.412 39.7389C186.27 40.6271 186.92 41.6669 187.361 42.8583C187.823 44.0497 188.054 45.3169 188.054 46.6599C188.054 49.1077 187.394 51.1765 186.072 52.8661C184.751 54.5557 182.989 55.8338 180.786 56.7003C178.606 57.5668 176.216 58 173.617 58Z" fill="#232A72" />
      <path className={fillClassName} d="M203.979 58C201.402 58 199.221 57.5234 197.437 56.5703C195.653 55.5955 194.299 54.3066 193.374 52.7036C192.471 51.1007 192.019 49.3352 192.019 47.4073C192.019 45.7176 192.306 44.2013 192.878 42.8583C193.451 41.4936 194.332 40.3238 195.521 39.349C196.711 38.3526 198.252 37.5402 200.147 36.912C201.578 36.4571 203.252 36.0456 205.168 35.6773C207.106 35.3091 209.199 34.9733 211.445 34.67C213.714 34.3451 216.081 33.9985 218.548 33.6302L215.707 35.2224C215.729 32.7963 215.178 31.0091 214.055 29.8611C212.932 28.713 211.038 28.1389 208.373 28.1389C206.765 28.1389 205.212 28.5072 203.715 29.2437C202.217 29.9802 201.171 31.2474 200.576 33.0454L193.308 30.8034C194.189 27.8357 195.863 25.4528 198.329 23.6549C200.818 21.857 204.166 20.958 208.373 20.958C211.544 20.958 214.33 21.467 216.731 22.4851C219.154 23.5033 220.949 25.1712 222.116 27.4891C222.755 28.7238 223.14 29.991 223.272 31.2908C223.405 32.5688 223.471 33.966 223.471 35.4824V57.0252H216.5V49.4218L217.656 50.6566C216.048 53.191 214.165 55.054 212.007 56.2454C209.87 57.4151 207.194 58 203.979 58ZM205.565 51.7613C207.371 51.7613 208.912 51.4472 210.19 50.819C211.467 50.1908 212.48 49.4218 213.229 48.512C214 47.6022 214.518 46.7466 214.782 45.9451C215.2 44.9486 215.432 43.8114 215.476 42.5333C215.542 41.2336 215.575 40.183 215.575 39.3815L218.019 40.0964C215.619 40.4646 213.56 40.7895 211.842 41.0711C210.124 41.3528 208.648 41.6235 207.415 41.8835C206.181 42.1218 205.091 42.3925 204.144 42.6958C203.219 43.0207 202.437 43.3998 201.798 43.8331C201.16 44.2663 200.664 44.7645 200.312 45.3277C199.981 45.8909 199.816 46.5516 199.816 47.3098C199.816 48.1763 200.036 48.9453 200.477 49.6168C200.917 50.2667 201.556 50.7866 202.393 51.1765C203.252 51.5664 204.309 51.7613 205.565 51.7613Z" fill="#232A72" />
    </svg>
  );
};

export const PopupCloseIcon = ({ mainClassName, strokeClassName }) => {
  return (
    <svg
      className={mainClassName}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_2465_10516)">
        <path
          className={strokeClassName}
          d="M14 2L2 14"
          stroke="#696E87"
          strokeWidth="2.4"
          strokeLinecap="round"
        />
        <path
          className={strokeClassName}
          d="M2 2L14 14"
          stroke="#696E87"
          strokeWidth="2.4"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2465_10516">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PlankRhomb = ({ mainClassName, fillClassName }) => {
  return (
    <svg
      className={mainClassName}
      xmlns="http://www.w3.org/2000/svg"
      width="1373"
      height="795"
      viewBox="0 0 1373 795"
      fill="none"
    >
      <path
        className={fillClassName}
        d="M686.218 0L1372.44 397.25L686.218 794.5L0 397.25L686.218 0Z"
      />
    </svg>
  );
};

export const PlankCloseIcon = ({
  mainClassName,
  fillClassName,
  bgClassName,
}) => {
  return (
    <svg
      className={mainClassName}
      xmlns="http://www.w3.org/2000/svg"
      width="78"
      height="78"
      viewBox="0 0 78 78"
      fill="none"
    >
      <rect
        className={bgClassName}
        width="78"
        height="78"
        rx="39"
        fill="white"
      />
      <rect
        className={fillClassName}
        x="52.4355"
        y="18.4939"
        width="10"
        height="48"
        rx="2"
        transform="rotate(45 52.4355 18.4939)"
        fill="#434661"
      />
      <rect
        className={fillClassName}
        x="18.4941"
        y="25.5649"
        width="10"
        height="48"
        rx="2"
        transform="rotate(-45 18.4941 25.5649)"
        fill="#434661"
      />
    </svg>
  );
};

export const PlankArrowIcon = ({ mainClassName, strokeClassName }) => {
  return (
    <svg
      className={mainClassName}
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
    >
      <path
        className={strokeClassName}
        d="M30 30L4 4"
        stroke="#F73F34"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className={strokeClassName}
        d="M29.9008 7.10889V29.8997L7.11328 29.8964"
        stroke="#F73F34"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LightningIcon = ({ mainClassName, fillClassName }) => {
  return (
    <svg
      className={mainClassName}
      xmlns="http://www.w3.org/2000/svg"
      width="57"
      height="72"
      viewBox="0 0 57 72"
      fill="none"
    >
      <path
        className={fillClassName}
        d="M32.3013 0L0 44H28.5L24.6987 72L57 28H28.5L32.3013 0Z"
        fill="#F73F34"
      />
    </svg>
  );
};
